import {IQuestionSet, ISection} from "@/consts/interfaces";
 
// work/work apiから取得したデータからchapter_idを利用して必要なsectionのデータを取得
function findSectionByChapterId(data: any, chapterId: number): ISection[] {
    const result: ISection[] = [];

    if (data instanceof Object) {
        if (data.id === chapterId && data.sections) {
            result.push(...data.sections);
        }
        for (const key in data) {
            if (data.hasOwnProperty(key)) { // プロパティが存在する場合のみ再帰
                const found = findSectionByChapterId(data[key], chapterId);
                result.push(...found);
            }
        }
    }
    return result;
}
// work/work apiから取得したデータからquestion_set_idsを利用して必要なsectionのデータを取得
function findSectionByQuestionSetId(data: any, questionSetIds: number[]): ISection[] {
    const result: ISection[] = [];

    if (data instanceof Object) {
        if (data.question_sets && data.question_sets.some((set: IQuestionSet) => questionSetIds.includes(set.id))) {
            result.push(data);
        }
        for (const key in data) {
            if (data.hasOwnProperty(key)) { // プロパティが存在する場合のみ再帰
                const found = findSectionByQuestionSetId(data[key], questionSetIds);
                result.push(...found);
            }
        }
    }

    return result;
}

export{findSectionByChapterId, findSectionByQuestionSetId}